import React, { useState, useMemo, useEffect } from 'react';
import { Button, Icon, Header, Table } from 'semantic-ui-react';
import _ from 'lodash';
import { numFormat } from '@rededompedro/utils';
import request from 'services/http';
import { finalize, tap } from 'rxjs/operators';
import { toast } from 'react-toastify';
import { DateTime } from 'luxon';
import { useSubscription, paramsToSearchURL } from 'utils';
import ModalDetalhes from '../extrato_cartoes/ModalDetalhes';
import history from 'services/history';

export default function Tabela({ dados, setDados, form, setLoadingTable, props }) {
    const [dadosExtrato, setDadosExtrato] = useState(null);
    const [dadosTurno, setDadosTurno] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [, setIsSubmitting2] = useState(false);
    const [dadosToSubmitExtrato] = useState(null);
    const [itemLista, setItemLista] = useState(null);
    const [showModalItem, setShowModalItem] = useState(false);
    const [isSubmittingTurno] = useState(false);

    useEffect(() => {
        if (itemLista !== null) {
            setShowModalItem(true);
        }
    }, [itemLista]);

    function voltarClicked() {
        if (dadosExtrato || dadosTurno) {
            setDadosExtrato(null);
            setDadosTurno(null);
        } else {
            setDados([]);
        }
    }

    //GET RELATÓRIO EXTRATO
    const submitRelatorio$ = useMemo(
        () =>
            request({
                url: '/conciliacao-cartao/extrato-cartao',
                method: 'GET',
                params: { ...dadosToSubmitExtrato },
            }).pipe(
                tap(({ response }) => {
                    if (response.data.length <= 0) {
                        toast.error('Dados não encontrados.');
                        return;
                    } else {
                        setDadosExtrato(response.data);
                    }
                }),
                finalize(() => {
                    setIsSubmitting(false);
                    setLoadingTable(false);
                }),
            ),
        [dadosToSubmitExtrato, setLoadingTable],
    );
    useSubscription(submitRelatorio$, isSubmitting);

    //GET RELATÓRIO TURNO
    const submitRelatorioturno$ = useMemo(
        () =>
            request({
                url: `/conciliacao-cartao/turno${props.location.search}`,
                method: 'GET',
            }).pipe(
                tap(({ response }) => {
                    if (response.data.length <= 0) {
                        toast.error('Dados não encontrados.');
                        return;
                    } else {
                        setDadosTurno(response.data);
                    }
                }),
                finalize(() => setIsSubmitting2(false)),
            ),
        [props.location.search],
    );
    useSubscription(submitRelatorioturno$, isSubmittingTurno);

    function handleSubmitExtrato(dados) {
        //console.log(dados)
    }

    function handleSubmitTurno(dados) {
        // setDadosToSubmitTurno(dados)
        let params = {};
        params['rest'] = dados.cod_emp;
        params['dateIdVenda'] = dados.id_data_venda;
        params['turno'] = dados.turno;
        history.push({ pathname: `${props.path}/turno`, search: paramsToSearchURL(params) });
    }

    function getSomaValor(dado, tipo) {
        if (tipo === 1) {
            let aux = null;
            dado.map((x) => (aux += x.valor_bruto));
            return numFormat(parseFloat(aux));
        } else if (tipo === 2) {
            let aux = null;
            dado.map((x) => (aux += x.valor_desconto));
            return numFormat(parseFloat(aux));
        } else if (tipo === 3) {
            let aux = null;
            dado.map((x) => (aux += x.valor_liquido));
            return numFormat(parseFloat(aux));
        } else if (tipo === 4) {
            let aux = null;
            dado.map((x) => (aux += x.valor));
            return numFormat(parseFloat(aux));
        }
    }

    function openModalItem(dados) {
        setItemLista(dados);
    }

    function getDiff(x) {
        let aux = null;
        aux = x.valor_total_caixa - x.valor_bruto_total;
        return numFormat(parseFloat(aux));
    }

    return (
        <React.Fragment>
            {dadosExtrato === null && dadosTurno === null ? (
                <Table color="grey" size="small" singleLine textAlign="center" compact="very">
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan="5">
                                <Header
                                    as="h5"
                                    color="grey"
                                    textAlign="right"
                                    style={{ margin: 0 }}
                                >
                                    Período de VENDA: {dados[0].data_venda} até{' '}
                                    {dados[dados.length - 1].data_venda}
                                </Header>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Data</Table.HeaderCell>
                            <Table.HeaderCell>Turno</Table.HeaderCell>
                            <Table.HeaderCell>Valor Caixa</Table.HeaderCell>
                            <Table.HeaderCell>Valor Extrato Cartão</Table.HeaderCell>
                            <Table.HeaderCell>Diferença</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {_.map(
                            dados,
                            (
                                { data_venda, turno, valor_bruto_total, valor_total_caixa },
                                index,
                            ) => (
                                <Table.Row key={index}>
                                    <Table.Cell>{data_venda}</Table.Cell>
                                    <Table.Cell>
                                        <Button
                                            style={{ width: '30%', fontWeight: 'bold' }}
                                            basic
                                            size="tiny"
                                            color="blue"
                                            onClick={() => handleSubmitTurno(dados[index])}
                                        >
                                            {turno}
                                        </Button>
                                    </Table.Cell>
                                    <Table.Cell>{numFormat(valor_total_caixa)}</Table.Cell>
                                    <Table.Cell>
                                        <Button
                                            style={{ width: '30%', fontWeight: 'bold' }}
                                            basic
                                            size="tiny"
                                            color="green"
                                            onClick={() => handleSubmitExtrato(dados[index])}
                                        >
                                            {numFormat(valor_bruto_total)}
                                        </Button>
                                    </Table.Cell>
                                    <Table.Cell>{getDiff(dados[index])}</Table.Cell>
                                </Table.Row>
                            ),
                        )}
                    </Table.Body>
                </Table>
            ) : null}

            {dadosExtrato ? (
                <Table
                    color="green"
                    size="small"
                    singleLine
                    className="mb-5"
                    textAlign="center"
                    compact="very"
                >
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan="10">
                                <Button
                                    floated="left"
                                    size="tiny"
                                    icon
                                    labelPosition="left"
                                    onClick={() => voltarClicked()}
                                >
                                    <Icon name="arrow left" />
                                    Voltar
                                </Button>
                                <Header
                                    floated="right"
                                    as="h5"
                                    textAlign="right"
                                    style={{ margin: 0 }}
                                >
                                    Período de VENDA: {form.dataInicio} até {form.dataFim}
                                </Header>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Data Venda</Table.HeaderCell>
                            <Table.HeaderCell>Data Caixa</Table.HeaderCell>
                            <Table.HeaderCell>Prev. Pagto</Table.HeaderCell>
                            <Table.HeaderCell>Nº Comprov.</Table.HeaderCell>
                            <Table.HeaderCell>Tipo Cartão</Table.HeaderCell>
                            <Table.HeaderCell>Vl. Bruto</Table.HeaderCell>
                            <Table.HeaderCell>Vl. Descto</Table.HeaderCell>
                            <Table.HeaderCell>Tx Descto</Table.HeaderCell>
                            <Table.HeaderCell>Vl. Líquido</Table.HeaderCell>
                            <Table.HeaderCell>Consultar</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {_.map(
                            dadosExtrato,
                            (
                                {
                                    descricao,
                                    data_venda,
                                    hora_venda,
                                    data_caixa,
                                    turno,
                                    id_prev_pagto,
                                    n_comprovante,
                                    valor_bruto,
                                    valor_desconto,
                                    tx_desc,
                                    valor_liquido,
                                },
                                index,
                            ) => (
                                <Table.Row key={index}>
                                    <Table.Cell>
                                        {data_venda}, {hora_venda}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {data_caixa} - {turno}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {DateTime.fromFormat(id_prev_pagto, 'yyMMdd').toFormat(
                                            'dd/MM/yyyy',
                                        )}
                                    </Table.Cell>
                                    <Table.Cell>{n_comprovante}</Table.Cell>
                                    <Table.Cell>{descricao}</Table.Cell>
                                    <Table.Cell>{numFormat(valor_bruto)}</Table.Cell>
                                    <Table.Cell>{numFormat(valor_desconto, 4)}</Table.Cell>
                                    <Table.Cell>{numFormat(tx_desc, 4)}</Table.Cell>
                                    <Table.Cell>{numFormat(valor_liquido)}</Table.Cell>
                                    <Table.Cell>
                                        <Button
                                            size="tiny"
                                            color="vk"
                                            onClick={() => openModalItem(dadosExtrato[index])}
                                        >
                                            + Detalhes
                                        </Button>
                                    </Table.Cell>
                                </Table.Row>
                            ),
                        )}
                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell colSpan="4" textAlign="left">
                                <Button
                                    size="tiny"
                                    icon
                                    labelPosition="left"
                                    style={{ margin: 0 }}
                                    onClick={() => voltarClicked()}
                                >
                                    <Icon name="arrow left" />
                                    Voltar
                                </Button>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Header
                                    floated="right"
                                    color="blue"
                                    style={{ font: 'Ubuntu', fontSize: 18 }}
                                >
                                    Total:
                                </Header>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Header color="blue" style={{ font: 'Ubuntu', fontSize: 18 }}>
                                    {getSomaValor(dadosExtrato, 1)}
                                </Header>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Header color="blue" style={{ font: 'Ubuntu', fontSize: 18 }}>
                                    {getSomaValor(dadosExtrato, 2)}
                                </Header>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Header color="blue" style={{ font: 'Ubuntu', fontSize: 18 }}>
                                    -
                                </Header>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Header color="blue" style={{ font: 'Ubuntu', fontSize: 18 }}>
                                    {getSomaValor(dadosExtrato, 3)}
                                </Header>
                            </Table.HeaderCell>
                            <Table.HeaderCell></Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
            ) : null}
            {showModalItem === true && (
                <ModalDetalhes
                    item={itemLista}
                    setItemLista={setItemLista}
                    setShowModalItem={setShowModalItem}
                />
            )}
        </React.Fragment>
    );
}
